<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-4">
              Confira abaixo a lista de usuários cadastrados. A seperação é
              feita de acordo com o tipo de usuário: administrador, startup ou
              investidor. Se existirem, os perfis com cadastrado incompleto
              serão exibidos em uma lista dedicada.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col">
          <div
            class="card shadow table-container vld-parent"
            ref="admins_table"
          >
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">
                    <i class="ni ni-key-25 pt-2 mr-2"></i> Lista de
                    <span class="text-orange">administradores</span>
                    <base-button
                      size="sm"
                      class="float-right mr-2 ml-2"
                      type="primary"
                      :custom="true"
                      @click="handleNewAdmin()"
                      ><i class="fas fa-plus mr-1"></i> Adicionar novo
                    </base-button>
                    <span
                      class="bg-white text-dark rounded border px-2 py-1 float-right font-weight-normal text-sm"
                      >exibindo
                      {{ adminsTableData.length }} administradores</span
                    >
                  </h3>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <base-table
                class="table align-items-center table-flush"
                thead-classes="thead-light"
                tbody-classes="list"
                :data="adminsTableData"
              >
                <template slot="columns">
                  <th>#</th>
                  <th>Administrador</th>
                  <th>Email</th>
                  <th>Ações</th>
                </template>
                <template slot-scope="{ row, index }">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <router-link
                      :to="`/admin/administradores/${row.id}/editar`"
                      class="btn btn-link pl-0"
                    >
                      {{ row.admin.name }}
                    </router-link>
                  </td>
                  <td>{{ row.email }}</td>
                  <td>
                    <router-link
                      :to="'/admin/administradores/' + row.id + '/editar'"
                      title="Editar administrador"
                      class="btn btn-white py-1 px-2"
                      ><i class="fas fa-edit text-info"></i
                    ></router-link>

                    <span
                      class="btn btn-white py-1 px-2"
                      @click="handleOpenModalConfirmation(row, 'administrador')"
                      title="Excluir administrador"
                      ><i class="fas fa-trash text-red"></i
                    ></span>
                  </td>
                </template>
              </base-table>
              <p
                v-if="!adminsTableData.length && adminsIsEmpty"
                class="text-center text-warning mt-3"
              >
                Não há administradores cadastrados até o momento
              </p>
            </div>
            <div
              class="card-footer pr-0 py-1 text-right"
              v-if="adminsTableData.length === initialLimit"
            >
              <base-button type="link" :custom="true" @click="loadAdmins()"
                >Carregar todos administradores</base-button
              >
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col">
          <div
            class="card shadow table-container vld-parent"
            ref="startups_table"
          >
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">
                    <i class="ni ni-key-25 pt-2 mr-2"></i> Lista de
                    <span class="text-orange">startups</span>
                    <span
                      class="bg-white text-dark rounded border px-2 py-1 float-right font-weight-normal text-sm"
                      >exibindo {{ startupsTableData.length }} startups
                    </span>
                  </h3>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <base-table
                class="table align-items-center table-flush"
                thead-classes="thead-light"
                tbody-classes="list"
                :data="startupsTableData"
              >
                <template slot="columns">
                  <th>#</th>
                  <th>Startup</th>
                  <th>Email</th>
                  <th>Ações</th>
                </template>
                <template slot-scope="{ row, index }">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <router-link
                      :to="`/admin/startups/${row.user.id}/editar`"
                      class="btn btn-link pl-0"
                    >
                      {{ row.name }}
                    </router-link>
                  </td>
                  <td>{{ row.user.email }}</td>
                  <td>
                    <router-link
                      :to="'/admin/startups/' + row.user.id + '/editar'"
                      title="Editar startup"
                      class="btn btn-white py-1 px-2"
                      ><i class="fas fa-edit text-info"></i>
                    </router-link>
                    <span
                      class="btn btn-white py-1 px-2"
                      title="Excluir startup"
                      @click="handleOpenModalConfirmation(row.user, 'startup')"
                      ><i class="fas fa-trash text-red"></i
                    ></span>
                  </td>
                </template>
              </base-table>
              <p
                v-if="!startupsTableData.length && startupsIsEmpty"
                class="text-center text-warning mt-3"
              >
                Não há startups cadastradas até o momento
              </p>
            </div>
            <div
              class="card-footer pr-0 py-1 text-right"
              v-if="startupsTableData.length === initialLimit"
            >
              <base-button type="link" :custom="true" @click="loadStartups()"
                >Carregar todas startups</base-button
              >
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col">
          <div
            class="card shadow table-container vld-parent"
            ref="investors_table"
          >
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">
                    <i class="ni ni-key-25 pt-2 mr-2"></i> Lista de
                    <span class="text-orange">investidores</span>
                    <span
                      class="bg-white text-dark rounded border px-2 py-1 float-right font-weight-normal text-sm"
                      >exibindo {{ investorsTableData.length }} investidores
                    </span>
                  </h3>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <base-table
                class="table align-items-center table-flush"
                thead-classes="thead-light"
                tbody-classes="list"
                :data="investorsTableData"
              >
                <template slot="columns">
                  <th>#</th>
                  <th>Investidor</th>
                  <th>Email</th>
                  <th>Ações</th>
                </template>
                <template slot-scope="{ row, index }">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <router-link
                      :to="`/admin/investidores/${row.user.id}/editar`"
                      class="btn btn-link pl-0"
                    >
                      {{ row.name }}
                    </router-link>
                  </td>
                  <td>{{ row.user.email }}</td>
                  <td>
                    <router-link
                      :to="'/admin/investidores/' + row.user.id + '/editar'"
                      title="Editar investidor"
                      class="btn btn-white py-1 px-2"
                    >
                      <i class="fas fa-edit text-info"></i
                    ></router-link>
                    <span
                      class="btn btn-white py-1 px-2"
                      title="Excluir investidor"
                      @click="
                        handleOpenModalConfirmation(row.user, 'investidor')
                      "
                      ><i class="fas fa-trash text-red"></i
                    ></span>
                  </td>
                </template>
              </base-table>
              <p
                v-if="!investorsTableData.length && investorsIsEmpty"
                class="text-center text-warning mt-3"
              >
                Não há investidores cadastrados até o momento
              </p>
            </div>
            <div
              class="card-footer pr-0 py-1 text-right"
              v-if="investorsTableData.length === initialLimit"
            >
              <base-button type="link" :custom="true" @click="loadInvestors()"
                >Carregar todos investidores</base-button
              >
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col">
          <div
            class="card shadow table-container vld-parent"
            ref="not_related_users_table"
          >
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">
                    <i class="ni ni-key-25 pt-2 mr-2"></i> Lista de
                    <span
                      title="Usuários que se registraram como startup ou investidor, mas não completaram as informações básicas."
                    >
                      <span class="text-orange">cadastros incompletos</span>
                      <i class="fas fa-info-circle ml-1"></i>
                    </span>
                    <span
                      class="bg-white text-dark rounded border px-2 py-1 float-right font-weight-normal text-sm"
                      >exibindo {{ notRelatedUsersTabelaData.length }} usuários
                    </span>
                  </h3>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <base-table
                class="table align-items-center table-flush"
                thead-classes="thead-light"
                tbody-classes="list"
                :data="notRelatedUsersTabelaData"
              >
                <template slot="columns">
                  <th>#</th>
                  <th>Tipo</th>
                  <th>Email</th>
                  <th>Ações</th>
                </template>
                <template slot-scope="{ row, index }">
                  <td>{{ index + 1 }}</td>
                  <td>
                    {{ getRoleName(row.roles) }}
                  </td>
                  <td>{{ row.email }}</td>
                  <td>
                    <span
                      class="btn btn-white py-1 px-2"
                      title="Excluir usuário"
                      @click="handleOpenModalConfirmation(row, 'usuário')"
                      ><i class="fas fa-trash text-red"></i
                    ></span>
                  </td>
                </template>
              </base-table>
              <p
                v-if="
                  !notRelatedUsersTabelaData.length && notRelatedUsersIsEmpty
                "
                class="text-center text-warning mt-3"
              >
                Não há usuários com cadastros incompletos no momento
              </p>
            </div>
            <div
              class="card-footer pr-0 py-1 text-right"
              v-if="notRelatedUsersTabelaData.length === initialLimit"
            >
              <base-button
                type="link"
                :custom="true"
                @click="loadNotRelatedUsers()"
                >Carregar todos usuários com cadastrados
                incompletos</base-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modalConfirmation.show"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-user-tie fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir o usuário [{{
              modalConfirmation.userType
            }}]
            <span class="text-warning">{{ modalConfirmation.userEmail }}</span
            >?
          </h4>
          <p class="mt-3 mb-0">
            Todas as informações relacionadas ao usuário [{{
              modalConfirmation.userType
            }}]
            <span class="text-warning">{{ modalConfirmation.userEmail }}</span>
            serão perdidas.
          </p>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="handleCloseModalConfirmation"
        >
          Voltar
        </base-button>
        <base-button type="white text-danger" @click="handleSubmitRemoveUser">
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "acessos_table",
  data() {
    return {
      adminsTableData: [],
      startupsTableData: [],
      investorsTableData: [],
      notRelatedUsersTabelaData: [],
      adminsIsEmpty: false,
      startupsIsEmpty: false,
      investorsIsEmpty: false,
      notRelatedUsersIsEmpty: false,
      modalConfirmation: {
        show: false,
        userId: null,
        userEmail: "",
        userType: "",
      },
      initialLimit: 10,
    };
  },
  mounted() {
    this.loadAdmins(this.initialLimit);
    this.loadStartups(this.initialLimit);
    this.loadInvestors(this.initialLimit);
    this.loadNotRelatedUsers(this.initialLimit);
  },
  methods: {
    async loadTableData(endpoint, targetObjName, loaderRef, emptyObjName) {
      const loader = this.$loading.show({
        container: loaderRef,
        width: 90,
        height: 90,
      });
      try {
        const { data } = await api.get(endpoint);
        if (data.length) this[targetObjName] = data;
        else this[emptyObjName] = true;
        loader.hide();
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as informações de acesso"
        );
      }
    },
    async loadAdmins(limit = "") {
      await this.loadTableData(
        `/admins${limit ? "?limit=" + limit : ""}`,
        "adminsTableData",
        this.$refs.admins_table,
        "adminsIsEmpty"
      );
    },
    async loadStartups(limit = "") {
      await this.loadTableData(
        `/adm/startups${limit ? "?limit=" + limit : ""}`,
        "startupsTableData",
        this.$refs.startups_table,
        "startupsIsEmpty"
      );
    },
    async loadInvestors(limit = "") {
      await this.loadTableData(
        `/adm/investors${limit ? "?limit=" + limit : ""}`,
        "investorsTableData",
        this.$refs.investors_table,
        "investorsIsEmpty"
      );
    },
    async loadNotRelatedUsers(limit = "") {
      await this.loadTableData(
        `/adm/users?not_related=true${limit ? "&limit=" + limit : ""}`,
        "notRelatedUsersTabelaData",
        this.$refs.not_related_users_table,
        "notRelatedUsersIsEmpty"
      );
    },
    handleOpenModalConfirmation(user, userType) {
      this.modalConfirmation.userId = user.id;
      this.modalConfirmation.userEmail = user.email;
      this.modalConfirmation.userType = userType;
      this.modalConfirmation.show = true;
    },
    handleCloseModalConfirmation() {
      this.modalConfirmation.show = false;
      this.modalConfirmation.userId = null;
      this.modalConfirmation.userEmail = "";
      this.modalConfirmation.userType = "";
    },
    async handleSubmitRemoveUser() {
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(`/adm/users/${this.modalConfirmation.userId}`);
        this.$toasted.show("Usuário removido com sucesso");
        this.$router.push("/admin/acessos");
        if (
          !this.removeFromList(
            this.modalConfirmation.userId,
            this.modalConfirmation.userType
          )
        )
          this.$router.go();
        this.handleCloseModalConfirmation();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao remover o usuário");
      } finally {
        loader.hide();
      }
    },
    handleNewAdmin() {
      this.$router.push("/admin/administradores/novo");
    },
    removeFromList(userId, userType) {
      let targetList = this.notRelatedUsersTabelaData;
      if (userType === "administrador") targetList = this.adminsTableData;
      else if (userType === "startup") targetList = this.startupsTableData;
      else if (userType === "investidor") targetList = this.investorsTableData;
      var index = targetList
        .map((user) => {
          return user.user_id || user.id;
        })
        .indexOf(userId);
      if (index === -1) return false;
      targetList.splice(index, 1);
      return true;
    },
    getRoleName(roles) {
      const role = roles[0];
      if (!role) return "-";
      const baseRoles = {
        investor: "Investidor",
        startup: "Startup",
        administrator: "Administrador",
      };
      return baseRoles[role.slug];
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 150px;
}
</style>
